import React, { useState } from 'react';
import styled from 'styled-components';
import { Markdown, Heading } from '../elements';

const MessageWrapper = styled.div`
  .message-header {
    background: ${(props) => props.theme.lightShades};
    border: 3px solid ${(props) => props.theme.backgroundColorLight};
    filter: drop-shadow(0px 20px 40px rgba(0, 0, 0, 0.25));
  }
`;

const FaqItem = ({ data }) => {
  const [active, setActive] = useState(false);
  if (!data) {
    return null;
  }
  return (
    <MessageWrapper className="">
      <div onClick={() => setActive(!active)} className="message">
        <div className="message-header mb-4">
          <Heading dark className="is-5 m-0">
            {data.question}
          </Heading>
          <div className="icon is-medium">
            <svg
              width="30"
              height="30"
              viewBox="0 0 49 49"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M42.269 8.90039L24.5 26.6694L6.731 8.90039L0 15.6314L24.5 40.1314L49 15.6314L42.269 8.90039Z"
                fill="#F4892F"
              />
            </svg>
          </div>
        </div>
      </div>
      {active && (
        <div className="px-4 pb-4">
          {data.description && (
            <Markdown className="message-body">{data.description}</Markdown>
          )}
        </div>
      )}
    </MessageWrapper>
  );
};

export default FaqItem;
